import api from './api';

// Admin › Infra › Legacy Ingress — what still calls the legacy stack (legacy_source_activity on the legacy database).
const legacyIngressService = {
    list:      (params)   => api.get('/admin/legacy-ingress', { params }),
    update:    (id, body) => api.put(`/admin/legacy-ingress/${id}`, body),
    // The decrypted API key of one row — audited as a READ, so it is fetched only when asked for.
    revealKey: (id)       => api.get(`/admin/legacy-ingress/${id}/api-key`),
    // The OHIP tab — who the legacy stack calls: every connector hc-ohipscheduler-run starts (legacy_target_activity).
    listOhip:   ()                  => api.get('/admin/legacy-ingress/ohip'),
    updateOhip: (connectorId, body) => api.put(`/admin/legacy-ingress/ohip/${connectorId}`, body),
    // Link to hub: which hub partner / chain / hotel each connector is (legacy_connector_links). Saving is incremental:
    // only the connectors named change. links: [{ connectorId, entityType: 'partner'|'account'|'hotel'|null, entityId }]
    ohipLinks:     ()      => api.get('/admin/legacy-ingress/ohip', { params: { view: 'links' } }),
    saveOhipLinks: (links) => api.post('/admin/legacy-ingress/ohip', { action: 'link-connectors', links }),
};

export default legacyIngressService;
